<template>
    <div v-scroll-window="callAllTaskList">
        <router-view v-resize-init="useThrottle(callTaskList)"/>
    </div>
</template>

<script lang="ts" setup>
import { callTaskList } from "@/app/providers/directives/Resize/state"
import { callAllTaskList } from "@/app/providers/directives/Scroll/state"
import { setCookie } from "@/plugins/cookie";
import { useThrottle } from "@/shared/lib/utils"
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

locale.value = 'ru';

setCookie('language', 'ru')
localStorage.setItem('locale', 'ru');

const publicRoutes = ['/doc/', '/policy', '/auth', '/register'];

if (publicRoutes?.some?.(route => location?.href?.includes?.(route)) == false) {
    localStorage.setItem('location', location?.pathname + location?.search)
}

</script>

<style lang="scss">

#app {
    width: 100vw;
    height: 100vh;
    // overflow: hidden;
}

#popups {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	contain: layout;
	pointer-events: none;
	// z-index: 1;
	z-index: 9999;
	width: 100vw;
}
#modals {
    position: fixed;
    top: 0;
    left: 0;

    contain: layout;
    pointer-events: none;
    // position: absolute;
    // display: contents;
}
#modals:not(:empty):has(*) {
    z-index: 1000;
    > * {
        z-index: 1000;
    }
}
html:has(.html-overflow-hidden) {
	overflow: hidden;
	#app {
		pointer-events: none !important;
		user-select: none !important;
	}
}

</style>
